<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 17 12"
    height="12"
    width="17"
    aria-hidden="true"
  >
    <path
      fill="currentColor"
      d="M13.809 5.222 9.058 1.1l1.108-1.1 6.041 6-6.04 6-1.11-1.102 4.752-4.12H.207V5.222h13.602Z"
    />
  </svg>
</template>
